import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

function isAdsCategoryLanding() {
  const template = document.querySelector('main[data-template]')?.dataset.template || '';
  return template.includes('collane-pietre-naturali') || template.includes('bracciali-pietre-naturali');
}

async function hydrateSection(sectionId, url) {
  const { buildSectionSelector, normalizeSectionId, sectionRenderer } = await import('@theme/section-renderer');
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') return;

  await sectionRenderer.renderSection(normalizedId, { cache: false, url, mode: 'hydration' });
  section.dataset.hydrated = 'true';
}

export async function hydrate(sectionId, url) {
  if (isAdsCategoryLanding()) return;

  onDocumentReady(() => {
    if (isAdsCategoryLanding()) return;
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}
